import apiClient from '../clients/apiClient';

export interface CartItem {
  id?: number;
  item_id: number;
  item_code: string;
  item_name: string;
  qty: number;
  unit_price: number;
  discount: number;
  total: number;
}

export const getCartItems = async (): Promise<CartItem[]> => {
  const response = await apiClient.get('/pos/cart');
  return response.data?.data || [];
};

export const addCartItem = async (item: CartItem): Promise<CartItem> => {
  const response = await apiClient.post('/pos/cart', item);
  return response.data?.data;
};

export const updateCartItem = async (id: number, updates: Partial<CartItem>): Promise<CartItem> => {
  const response = await apiClient.put(`/pos/cart/${id}`, updates);
  return response.data?.data;
};

export const removeCartItem = async (id: number): Promise<void> => {
  await apiClient.delete(`/pos/cart/${id}`);
};

export const clearCartItems = async (): Promise<void> => {
  await apiClient.delete('/pos/cart');
};
